import { defineStore } from 'pinia'
const imgPath: string = window.imgpath || import.meta.env.VITE_IMGPATH

export const useStore = defineStore('main', {
  state: () => ({
    currentStep: 0,
    shape: '',
    cushion: '',
    edgeSewing: '',
    width_a_rectangle: '',
    length_b_rectangle: '',
    diameter_a_circle: '',
    thickness: 0,
    buttonsCols: '',
    buttonsRows: '',
    stitchesCols: '',
    stitchesRows: '',
    isStitches: '' as '' | 'stitches_yes' | 'stitches_no',
    isButtons: '' as '' | 'buttons_yes' | 'buttons_no',
    isButtonMiddle: '' as '' | 'button_middle_yes' | 'button_middle_no',
    buttonsDistribution: '',
    stitchesDistribution: '',
    buttonsDistanceToEdge: '',
    stitchesDistanceToEdge: '',
    topStitchesType: '' as '' | 'top_stitches_single' | 'top_stitches_double',
    isJqueryAjaxEventAdded: false,
    name: '',
    quantity: 1,
    currentMaterialType: '',
    selectedFabric: {
      id: '',
      name: '',
      image: '',
    },
    fabrics: {
      type: 'top',
      text: 'Top, sides & buttons',
      data: {
        id: '',
        name: '',
        image: '',
      },
    },

    count: '',
    typeSwitchImgName: '',
    renderProductImgName: '',
    crossTopSewing: '' as '' | 'cross_top_sewing_yes' | 'cross_top_sewing_no',

    imgPath: imgPath,
    cushionBottom: '' as '' | 'anti_slip_cushion_bottom_type' | 'reversible_cushion_bottom_type',

    shapes: [
      {
        type: 'rectangle',
        name: 'Rectangle',
        smallBorderImage: `${imgPath}/shape_small_rectangle.svg`,
        normalBorderImage: `${imgPath}/shape_normal_rectangle.svg`,
        normalBorderImageHover: `${imgPath}/shape_normal_rectangle-hover.svg`,
        smallBorderImageWhite: `${imgPath}/shape_small_rectangle_white.svg`,
        infoImageUrl: `${imgPath}/rectangle.png`,
        text: '<p>Define the lengths of the 2 sides: <br><b><u>a</u></b> and <b><u>b</u></b></p>',
      },
      {
        type: 'circle',
        name: 'Circle',
        smallBorderImage: `${imgPath}/shape_small_circle.svg`,
        normalBorderImage: `${imgPath}/shape_normal_circle.svg`,
        normalBorderImageHover: `${imgPath}/shape_normal_circle-hover.svg`,
        smallBorderImageWhite: `${imgPath}/shape_small_circle_white.svg`,
        infoImageUrl: `${imgPath}/circle.png`,
        text: '<p>Please define the length of the diameter: <br><b><u>a</u></b></p>',
      },
    ],
  }),
  getters: {
    fabricTop: (state) => state.fabrics.type === 'top',
    isCircle: (state) => state.shape === 'circle',
    isRectangle: (state) => state.shape === 'rectangle',
  },
  actions: {
    changeFabrics(
      value: {
        type: string
        data: {
          id: string
          name: string
          image: string
        }
      }[],
    ) {
      value.map((changeItem) => {
        const fabricToBeChanged = this.fabrics.type === changeItem.type
        if (fabricToBeChanged) this.fabrics.data = changeItem.data
      })
    },
    nullForm() {
      this.shape = ''
      this.cushion = ''
      this.edgeSewing = ''
    },
    nullMaterial() {
      this.fabrics = {
        type: 'top',
        text: 'Top, sides & buttons',
        data: {
          id: '',
          name: '',
          image: '',
        },
      }

      this.cushionBottom = ''
      this.currentMaterialType = ''
      this.selectedFabric = {
        id: '',
        name: '',
        image: '',
      }
    },
    nullSize() {
      this.width_a_rectangle = ''
      this.length_b_rectangle = ''
      this.diameter_a_circle = ''
      this.isButtonMiddle = ''
      this.isButtons = ''
      this.buttonsRows = ''
      this.buttonsCols = ''
      this.buttonsDistanceToEdge = ''
      this.buttonsDistribution = ''
      this.isStitches = ''
      this.stitchesDistanceToEdge = ''
      this.stitchesDistribution = ''
      this.stitchesCols = ''
      this.stitchesRows = ''
      this.thickness = this.cushion !== 'flat_cushion' ? 3 : 5
    },
    changeThickness(value: number) {
      this.thickness = value
    },
    changeButtonsCols(value: string) {
      this.buttonsCols = value
    },
    changeRowsOfButtons(value: string) {
      this.buttonsRows = value
    },
    changeStitchesCols(value: string) {
      this.stitchesCols = value
    },
    changeStitchesRows(value: string) {
      this.stitchesRows = value
    },
    changeIsStitches(value: 'stitches_yes' | 'stitches_no') {
      this.isStitches = value
    },
    changeTopStitchesType(value: 'top_stitches_single' | 'top_stitches_double') {
      this.topStitchesType = value
    },
    changeIsButtons(value: 'buttons_yes' | 'buttons_no') {
      this.isButtons = value
    },
    changeIsButtonMiddle(value: 'button_middle_yes' | 'button_middle_no') {
      this.isButtonMiddle = value
    },
    changeName(value: string) {
      this.name = value
    },
    changeQuantity(v: number) {
      if (v < 1 || isNaN(v)) {
        v = 1
      }
      this.quantity = v

      if (import.meta.env.NODE_ENV === 'development') {
        return
      }
      const qty = document.getElementById('qty') as HTMLInputElement
      qty.value = String(v)
      const event = new Event('change')
      qty.dispatchEvent(event)
    },
    changeButtonsDistribution(value: string) {
      this.buttonsDistribution = value
      if (value !== 'distribution_fixed_distance') {
        this.buttonsCols = ''
        this.buttonsRows = ''
        this.buttonsDistanceToEdge = ''
      }
    },
    changeStitchesDistribution(v: string) {
      this.stitchesDistribution = v
      if (v !== 'stitches_distribution_fixed_distance') {
        this.stitchesCols = ''
        this.stitchesRows = ''
        this.stitchesDistanceToEdge = ''
      }
    },
  },
  persist: {
    storage: localStorage,
    debug: true,
  },
})
